<script lang="ts">
  import { CopyButton } from 'carbon-components-svelte';

  import type { AttributeOptions, BuildEnv, EmbedValue, TestingQueryAttributes } from '../modules/attributes';
  import { camelToSnakeCase, getDefaultBuild, snakeCaseAttributes } from '../modules/attributes';

  type Props = {
    attributes: AttributeOptions & TestingQueryAttributes;
    buildEnv: BuildEnv;
    embedValue: EmbedValue;
  };

  const { attributes, buildEnv, embedValue }: Props = $props();

  function createSrcToCopy(attr = attributes, embed = embedValue, build = buildEnv) {
    const root = `${window.location.origin}`;
    let urlToCopy = '';
    urlToCopy = `${(Object.keys(attr) as Array<keyof typeof attr>).reduce((agg, key) => {
      const queryKey = snakeCaseAttributes.includes(key) ? camelToSnakeCase(key) : key;
      if (attr[key] !== undefined && attr[key] !== null && attr[key] !== '') {
        if (!agg) {
          return `${root}/index.html?` + `${queryKey}=${attr[key]}`;
        }

        return agg + `&${queryKey}=${attr[key]}`;
      }

      return agg;
    }, '')}`;

    if (embed !== 'iframe') {
      urlToCopy = urlToCopy ? `${urlToCopy}&embed=${embed}` : `${root}/index.html?embed=${embed}`;
    }

    if (build !== getDefaultBuild()) {
      urlToCopy = urlToCopy ? `${urlToCopy}&build=${build}` : `${root}/index.html?build=${build}`;
    }

    return urlToCopy ?? root;
  }

  const srcToCopy = $derived(createSrcToCopy(attributes, embedValue, buildEnv));
</script>

<CopyButton text={srcToCopy} feedback="Config copied" />
